<template>
  <div class="cpunk_page with-navbar">
    <div class="only-desktop">
      <top-bar></top-bar>
    </div>
    <rebuild-nav-bar></rebuild-nav-bar>

    <div class="protocol-container">
      <h1 class="protocol-title only-mobile">&nbsp;保乐力加（中国）<br>贸易有限公司隐私条款</h1>
      <h1 class="protocol-title only-desktop">&nbsp;保乐力加（中国）贸易有限公司隐私条款</h1>
      <div class="desc">
        <p class="mt20">保乐力加（中国）贸易有限公司（以下称”本公司”或“我们”）尊重每一位客户的隐私权。本隐私权政策（以下称”本政策”）将介绍本公司收集的信息的种类，我们使用该信息的范围与目的、该等信息的处理与转移以及我们对该信息的保护。本政策适用于访问、浏览本公司网站或本公司其他平台的人士或者其它以各种方式进入或使用本公司网站或本公司其他平台的人员。本政策所称“本公司网站”和“本公司其他平台”包括但不限于本公司的官方网站主页及处于同一顶级域名下的其它页面，以及其中的所有内容和所提供的服务、本公司或经过本公司授权运营的公众（订阅）号交流平台及其中本公司或经本公司授权发布的所有内容、本公司应用软件及其提供的服务和发布的所有内容、本公司或本公司授权的电商及其中本公司或经本公司授权提供的服务和发布的所有内容，以下合称“本公司各大平台”。</p>
        <p class="mt20">我们的保护隐私权政策源于中国适用的相关工业指导原则和标准，以及地方性的、国内的和国际的相关法律和惯例。通过在电脑、手机、笔记本、控制台或其他设备（以下统称“设备”）上使用或浏览本公司各大平台及其提供的相关服务，意味着您已充分阅读、理解并接受本政策并同意受其约束。如您对本政策的任何部分有任何异议，请勿使用或浏览本公司各大平台。</p>
        <p class="mt20">我们可能根据适用的法律法规与其他需要不时对本政策进行更新。我们建议您定期查看本政策以确保您了解具有约束力的本政策的最新版本。</p>
        <p class="mt20">本隐私政策旨在描述本公司普遍的隐私政策，我们的目标是要在对您最具影响的时刻，提供更详细的信息给您。请在我们的服务中注意该等通知。</p>
      </div>

      <h5 class="sub-title">年龄要求</h5>
      <p>本公司各大平台仅限于达到当地法定购买酒类年龄的用户使用。如您并未达到您居住地或上网所在地法定购买酒类的年龄，请不要向我们提供您的个人信息（定义如下）。本公司从未意图收集任何未到法定购买酒类年龄的人群的个人信息或向此类人群推广我们的产品。未达到法定购买酒类年龄的用户，禁止使用本公司各大平台以及本公司各大平台所提供的相关服务。为了保证我们仅向达到当地法定购买酒类年龄的用户提供相关服务，我们可能以匿名的方式收集您的出生日期。这些信息将仅用于确认您是否达到了购买酒类的法定年龄，在确定您的年龄后，我们将立即删除这些信息。</p>
      <h5 class="sub-title">我们可能收集的信息</h5>
      <p>在您访问、浏览和使用本公司各大平台的过程中，我们可能收集关于您的以下信息：</p>
      <p>您提供的信息，包括您提供的个人信息与您提供的共享信息。</p>
      <p>个人信息。个人信息是指与特定自然人相关、能够单独或通过与其他信息结合识别该特定自然人的相关数据。我们仅向您收集您同意并向我们提供的个人信息。我们会收集和保留一定的个人信息，包括但不限于您在注册、登陆、使用本公司各大平台时提供的个人姓名、电话号码、地址和电子邮件等信息、您对于我们产品的消费和喜好信息、位置（GPS）信息、信用卡和支付平台相关信息（如必要）；</p>
      <p>共享信息是指您通过社交媒体上传的任何信息或资料，无论是姓名、个人资料、照片、视频、故事、想法、评论、创意概念、信息或其他发布资料。</p>
      <p>我们从其他方（包括但不限于您授权的第三方、我们的关联公司、母公司以及合作伙伴）处收集的您的信息。我们可能将您提供给我们的或我们收集的信息与来自于本公司渠道、交易和通信的其他信息相结合，可能包括但不限于，来自本公司线上及线下店铺、直邮、产品目录、活动、产品和应用或其他与本公司的互动信息。我们还可能将该等信息与公开资料和来自第三方的数据相结合。我们还收集礼物给予者或您授权的第三方提供的关于礼物接受者或您的信息。如果我们将您提供给我们的或来自与本公司互动而来的或第三方的提供的信息相结合，该等相结合的信息将会被视为个人信息，只要该等信息保持相结合的状态。为预防欺诈和确保安全，我们的关联公司、母公司及合作伙伴会依据适用的法律法规或征得您同意的前提下，向我们分享您的信息。</p>
      <p>我们自动向您收集的信息。通过该等信息的收集，我们可以了解如何使我们的网站、电商、产品和相关服务更加符合您的需求。您在此明确同意，在您访问、浏览及使用本公司各大平台时，我们可能通过cookies（关于cookies请见下文第4条有关于cookies的详细描述）或其他方式自动采集这些以下设备信息、操作信息和位置信息：</p>
      <p>设备信息</p>
      <p>设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址（IP地址是您在使用互联网时为您的计算机分配的一个数字。该信息不包含任何有关您的个人身份识别信息。您的IP地址还用于帮助在某一具体会话过程中对您进行识别以及收集广泛的统计数据）和移动设备所用的版本和设备识别码。</p>
      <p>操作信息</p>
      <p>在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；</p>
      <p>有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；</p>
      <p>您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；</p>
      <p>您访问本公司各大平台或使用我们服务时所进行的操作以及您在本公司各大平台上进行交易的相关信息。</p>
      <p>位置信息</p>
      <p>您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；</p>
      <p>您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；</p>
      <p>大多数移动设备将允许您关闭定位服务，我们建议您咨询相关移动设备的销售商或生产商。</p>
      <p>如果您不愿意向我们提供上述信息，您仍可访问我们的网站的部分内容，但您可能无法全面享受注册用户的相关权益或参加某些促销活动或收到我们的推广信息。</p>
      <h5 class="sub-title">关于Cookies</h5>
      <p>Cookie是一种登记用户在使用网站时的偏好，以确保用户获得更佳、更个性化体验的常规方法。该等偏好信息存储于您计算机硬盘驱动器上的文件中。例如，一个cookie可能会包含您所偏好的居住国，这样在您每次访问时我们将无须向您询问该问题。</p>
      <p>我们还使用“分析”cookie，它使我们能够确认并计算访问者的数量，以及查看这些访问者在使用本公司各大平台时在各大平台上的移动模式。这有助于我们改进本公司各大平台的工作方式，比如确保用户轻松找到所需的内容。</p>
      <p>我们的网站同时采用持久cookie和会话cookie两种cookie。持久cookies一直驻留在您的计算机上，直到您“手动”删除它们。会话cookies则在您离开一个网站并进入另一个站点或关闭浏览器后自动将自己删除。</p>
      <p>有关cookies的更多信息，包括如何激活cookie，如何更改浏览器设置以及如何在硬盘驱动器上找到并删除cookie的信息，请参见您浏览器上的帮助菜单或访问以下网站： www.allaboutcookies.org。</p>
      <h5 class="sub-title">信息的使用</h5>
      <p>我们会将收集的关于您的信息用于如下方面：</p>
      <p>向您提供您使用的各项服务以及其他您可能感兴趣的服务</p>
      <p>我们将会使用您提供的个人信息用于您所要求的各项服务，以及其他您可能感兴趣的服务。</p>
      <p>在您明示同意的条件下，我们会使用您提供的信息向您联系并发送我们、我们关联公司、母公司以及与之相关的业务的产品、服务与促销信息。这种服务是选择性的，您可随时决定退出这些服务。</p>
      <p>改进提供的服务和产品</p>
      <p>我们还使用您的个人信息来改进我们的促销工作，以统计学方式分析网站的使用状况；改进我们的内容和提供的产品；按用户的要求制作网站内容、布局和服务项目。我们相信该等使用，使我们能够改进我们的网站，使其更好地为来访人士服务。</p>
      <p>按您的要求向第三人发送信息</p>
      <p>如您使用了我们的社交媒体，我们也有可能按照您提供的第三人信息向第三人发送您定制的本公司各大平台的信息、资料或服务。我们提醒您我们仅按您的需求向该等第三人发送信息，并未鼓励该等第三人饮用酒类产品。未得到该等个人的明示同意，我们不会向其发送其他相关信息。请确保该等第三人已达到当地购买酒类产品的法定年龄。</p>
      <p>用于相关的电商服务</p>
      <p>如您使用了本公司各大平台的电商服务，我们还可能使用您的个人信息回复您关于产品购买的询问，记录您的消费信息，在必要时与您联系，以及其他为完成您的订单而使用您的个人信息。</p>
      <h5 class="sub-title">集成和统计数据的使用</h5>
      <p>本公司利用网站记录信息（如：你的网站浏览器、操作系统、所查看的网页等）来帮助我们设计网站、识别热销的特色产品，及用于其他管理方面。我们以匿名化的方式使用这些信息，例如有多少用户访问了本公司各大平台，有多少网页被访问等等。我们不会将这些信息识别塔顶个人。但是，必要时，我们会使用网站记录以帮助识别是否有人想闯入或破坏我们的网站，如果我们确信有证据表明有破坏计算机安全或违反有关法律的行为，我们会与执法部门共享网站记录信息。</p>
      <h5 class="sub-title">信息共享</h5>
      <p>在没有得到您同意时，我们不会将来访人士的个人信息，出售给任何与本公司向您提供服务不相关的企业或个人使用。但是，您在此充分理解并明确同意，在以下情况下，我们将与第三方共享您的个人信息，前提是该等第三方明确了解并遵守本政策，并以不低于本政策的程度对您的个人信息进行保护：</p>
      <p>作为保乐力加集团的一员，我们可能在提供本公司各大平台服务时使用我们关联公司或母公司的资源，因此，在遵守当地法律的情况下，我们可能向我们关联公司或母公司披露您的个人信息；</p>
      <p>任何经您同意共享信息的第三方；</p>
      <p>当您使用一些特定的服务（包括但不限于订阅我们的微信公众号、成为我们社交平台的用户）时，您同意向我们提供或公开分享一些基本的信息，可能包括您的用户名、所在城市和头像图片；</p>
      <p>您可以选择共享特定的信息。为了使用特定的功能，您可能需要调整您的隐私设置并且分享更多的信息。您也可以选择将您的活动于其他平台上共享，例如微博和微信。请阅读该等平台的隐私政策，因为您在该等平台上公开的活动将不再适用本公司的隐私政策；</p>
      <p>公开共享的信息可能会被我们用于推广目的；</p>
      <p>为更好地向您提供服务，我们可能将您的信息提供给我们的代理、供应商、分包商或合作伙伴以供其代表我们履行本公司各大平台的服务（例如：提供社交媒体上的服务的供应商）或向您提供本公司各大平台或您要求的其他服务，包括但不限于为完成您的订单而向仓储或物流公司提供的您的订单信息、为完成交易而与支付相关方提供您的信用卡与支付信息、向我们广告与市场供应商提供您的信息供其向您发送相关信息、为分析网站的使用情况而与分析方共享我们相关的数据、以及其他为服务之目的与第三方共享您的个人信息。但上述人员不得将该信息用于其他方面也不能与不共同提供服务的任何第三方共享或重新出售这种数据。同时，上述人员使用您的个人信息的范围将仅限于与本公司为您提供服务相关的服务；</p>
      <p>在出售业务、合并、重组、转换控制权、转移重大资产、融资或清算的情况下，我们可能向第三方转让、出售或指定向第三方转移包含您的个人信息在内的业务；</p>
      <p>在强制执行、政府或法律部门或其他为遵循法律强制规定的第三方要求下，在我们相信为遵守法律的强制规定有必要的前提下，或者我们为调查、保护或为本公司抗辩的情况下，我们可能会与第三方分享您的信息。</p>
      <h5 class="sub-title">第三方追踪</h5>
      <p>我们还与其他代表我们在整个互联网上使用追踪技术来投放广告的公司合作。这些公司可能收集您与我们的互动信息，包括广告。如果您希望选择退出接收与本网站相关的第三方追踪技术制作的广告，请点击这里。请注意，如果您选择退出这些第三方追踪技术，您可能仍会看到其他网站上我们的广告，但是该等广告并非与本网站相关的第三方利用追踪技术制作的广告。</p>
      <h5 class="sub-title">信息的转移</h5>
      <p>通过向我们提供信息，您充分知晓、理解并明确同意，在遵守当地法律法规的前提下，我们可能将该等个人信息转移至其他国家或地区，或者在这些国家或地区对个人信息进行处理。我们对个人信息的转移与处理都将遵循本政策相关规定；您充分知晓、理解并明确同意您的个人信息将通常被储存在本公司的数据库内，该种数据库分布于世界各地，包括美国与欧盟，并将根据本公司业务需要进行转移。无论您的个人信息储存在何处，本公司都会采取同样的数据保护标准，并按照本声明所规定的方式和目的使用您的个人信息。</p>
      <h5 class="sub-title">信息安全与责任</h5>
      <p>本公司承诺将保护您提供给我们的个人信息的安全，并采取合理的防范措施，以免您的个人信息被丢失、滥用或更改。我们承诺采用适当的物理、电子以及其他手段与程序保护我们收集到的个人信息。</p>
      <p>鉴于本公司的代理、供应商、分包商或合作伙伴，在向本公司提供服务时，能够看到您的个人信息，我们则要求他们对该信息进行保密，除了在为本公司提供服务方面，不得以任何其他方式和目的使用该信息。</p>
      <p>本公司对您提供的各项个人信息的内容将不进行评价、更改或确认，本公司对您的个人信息的采集、使用和披露均是本公司相关网站的自动筛选行为，本公司不对您的个人信息进行内容审核和修改，因此，为了本公司为您提供准确有效的各项服务，强烈建议您保证确保您提供的个人信息的准确性和真实性。</p>
      <p>您需要明确，同其他公司一样，对于您与我们所进行的交流中所含的个人信息，我们并不能完全保护。并且，您在社交媒体上发布的任何信息通常是公开并且不受保护的，可能会被其它人收集并使用，从而导致非自愿地收到来自其它人的信息。因此，我们建议您在上述的交流与社交媒体上不要包含任何保密、专有或其他敏感的个人信息。</p>
      <p>尽管有上述约定，本公司并不保证您的信息不受不可抗力、恶意计算机程序等的侵害。</p>
      <h5 class="sub-title">请求</h5>
      <p>您有权访问、更正和删除保乐力加所掌握的您的数据。经您要求，我们将会尽合理的努力从本公司以及按本政策条款共享您的个人信息的第三方的后台文件中删除您的可识别信息。</p>
      <p>如您当前正接收保乐力加的直接营销，但不希望保乐力加继续使用或向他人提供您的资料用于直接营销，则您可通过【发出书面请求/点击退订链接】行使您的退出选择权，且无需支付费用。要取消订阅、停止接收消息，请更改您的设置或按照电子邮件、短信、通知或其他消息类型的指示进行。如您取消订阅任何关于本公司的通信，由于通信制作周期的原因，您仍可能接收到已在制作中的通信。</p>
      <h5 class="sub-title">第三方链接</h5>
      <p>本公司各大平台可能含有我们无法控制的其他第三方的链接、推介与内容。请注意我们对于此类网站仅有有限的或无法对该类网站进行控制与管理。本政策并不适用该等网站。我们强烈建议您在访问、浏览和使用该等网站时阅读他们的隐私权政策以及条款与条件。</p>
      <h5 class="sub-title">联系方式</h5>
      <p>如您有任何需求需要我们协助（包括本政策第10条之请求），请按以下联系方式与我们联系：</p>
      <p>公司名称：保乐力加(中国)贸易有限公司</p>
      <p>公司地址：中国上海市湖滨路168号企业天地商业中心3号楼15楼</p>
      <p>邮政编码: 200021</p>
      <p>电话：+8621 2301 1000</p>
      <p>电子邮件：</p>
      <p>【PRCCorporate.Communications@pernod-ricard.com】</p>
      <p class="mt40">本人已经认真阅读并同意以上所有内容。</p>
    </div>

    <page-footer></page-footer>
  </div>
</template>

<script>
import TopBar from '@components/TopBar'
import RebuildNavBar from '@components/RebuildNavBar'
import PageFooter from '@components/PageFooter'

export default {
  name: 'Protocol',
  components: {
    TopBar,
    RebuildNavBar,
    PageFooter,
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.protocol-container {
  padding: 40px 30px;
  text-align: justify;
  font-weight: 500;
  font-size: 1.2rem;
  color: #fff;
  line-height: 180%;
  position: relative;
  @include respond-to(desktop) {
    max-width: 960px;
    margin: 0 auto;
    line-height: 200%;
  }
  .protocol-title {
    margin-bottom: 24px;
    font-weight: 900;
    font-size: 2rem;
    color: #fff;
    opacity: 0.9;
    text-align: center;
    font-family: 'Absolut-Bold';
    // text-shadow: 2px 2px 0 nth($green, 3);
  }
  .sub-title {
    margin: 24px 0 8px;
    font-weight: bold;
    font-size: 2rem;
    color: #fff;
    text-align: center;
    @include respond-to(desktop) {
      text-align: left;
      font-size: 1.4rem;
    }
  }
  .desc {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Protocol.vue